import React from "react";

const NAVY = "#182848";
const ORANGE = "#EE7623";
const SLATE = "#4A5A72";
const GREY = "#9AA3B2";
const GREY_LINE = "#C5CBD6";

const SOLO = ["Roofer", "Window installer", "Carpet cleaner", "Painter", "Admin & scheduling"];
const HCOB = ["Roofing", "Windows", "Carpet & flooring", "Painting", "Admin & scheduling"];

// Inline SVG (not <img>) so the copy is selectable, crawlable and recolorable.
export const HowItWorksDiagram = () => (
  <svg
    viewBox="0 0 800 822"
    role="img"
    aria-labelledby="hiw-title hiw-desc"
    className="mx-auto block h-auto w-full max-w-[720px]"
    style={{ fontFamily: "inherit" }}
    data-testid="how-it-works-diagram"
  >
    <title id="hiw-title">How HCOB Property Services works: one contact instead of five contractors</title>
    <desc id="hiw-desc">
      On your own you search, quote and schedule a roofer, window installer, carpet cleaner, painter and admin separately — five quotes, five schedules, and you are the project manager. With HCOB Property Services you make one call to one contact, and HCOB coordinates roofing, windows, carpet and flooring, painting and scheduling as one accountable team.
    </desc>
    <defs>
      <marker id="hiw-arrow" viewBox="0 0 10 10" refX="8" refY="5" markerWidth="7" markerHeight="7" orient="auto-start-reverse">
        <path d="M0 0L10 5L0 10z" fill={NAVY} />
      </marker>
    </defs>
    <rect width="800" height="822" fill="#FDF3EA" />

    {/* ── On your own ── */}
    <text x="40" y="58" fontSize="21" fontWeight="700" letterSpacing="2.5" fill={GREY}>ON YOUR OWN</text>
    <circle cx="78" cy="235" r="38" fill="#FDF3EA" stroke="#B7BFCC" strokeWidth="3" />
    <text x="78" y="243" fontSize="22" fontWeight="700" fill="#7D8798" textAnchor="middle">YOU</text>
    {SOLO.map((label, i) => {
      const y = 118 + i * 50;
      const cy = y + 21;
      return (
        <g key={label}>
          <path d={`M116 235 C 210 235, 270 ${cy}, 370 ${cy}`} fill="none" stroke={GREY_LINE} strokeWidth="2.5" />
          <rect x="370" y={y} width="390" height="42" rx="6" fill="#F7F8FA" stroke="#B7BFCC" strokeWidth="2" />
          <text x="390" y={y + 30} fontSize="25" fontWeight="600" fill="#6B7688">{label}</text>
          <text x="740" y={y + 30} fontSize="23" fontWeight="600" fill={GREY} textAnchor="end">{`quote ${i + 1}`}</text>
        </g>
      );
    })}
    <text x="40" y="405" fontSize="27" fontWeight="700" fill={SLATE}>5 searches. 5 quotes. 5 schedules.</text>
    <text x="40" y="440" fontSize="27" fontWeight="700" fill={SLATE}>You are the project manager.</text>

    <line x1="40" y1="470" x2="760" y2="470" stroke="#E6D9CC" strokeWidth="2" />

    {/* ── With HCOB ── */}
    <text x="40" y="518" fontSize="21" fontWeight="700" letterSpacing="2.5" fill={ORANGE}>WITH HCOB PROPERTY SERVICES</text>
    <circle cx="78" cy="655" r="38" fill="#FDF3EA" stroke={NAVY} strokeWidth="3" />
    <text x="78" y="663" fontSize="22" fontWeight="700" fill={NAVY} textAnchor="middle">YOU</text>
    <rect x="122" y="650" width="30" height="10" fill={ORANGE} />
    <polygon points="150,640 172,655 150,670" fill={ORANGE} />
    <rect x="178" y="612" width="172" height="82" rx="8" fill={NAVY} />
    <text x="264" y="650" fontSize="28" fontWeight="800" fill="#FFFFFF" textAnchor="middle">HCOB</text>
    <text x="264" y="676" fontSize="15" fontWeight="700" letterSpacing="1.5" fill={ORANGE} textAnchor="middle">ONE CONTACT</text>
    {HCOB.map((label, i) => {
      const y = 538 + i * 48;
      const cy = y + 20;
      return (
        <g key={label}>
          <path d={`M350 655 C 380 655, 388 ${cy}, 414 ${cy}`} fill="none" stroke={NAVY} strokeWidth="2.5" markerEnd="url(#hiw-arrow)" />
          <rect x="418" y={y} width="342" height="40" rx="6" fill="#FFFFFF" stroke={NAVY} strokeWidth="2.5" />
          <text x="440" y={y + 29} fontSize="25" fontWeight="700" fill={NAVY}>{label}</text>
        </g>
      );
    })}
    <text x="40" y="802" fontSize="28" fontWeight="800" fill={NAVY}>One call. One quote. One accountable team.</text>
  </svg>
);
